import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import EachFeature from "./EachFeature";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Button from "./Button";

const Features = ({ data }) => {
  const { feature_button, features } = data !== undefined && data;
  const settings = {
    dots: features?.benefits.length > 3,
    infinite: false,
    autoplay: false,
    speed: 900,
    cssEase: "linear",
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640, // Adjust this breakpoint as needed
        settings: {
          dots: features?.benefits.length > 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
        },
      },
    ],
    arrows: false,
  };
  return (
    <div>
      <Header headingData={features} />
      <div id="invest-slider" className="w-[90%] m-auto md:mt-[2vw] mt-[5vw]">
        <Slider {...settings}>
          {features?.benefits?.length > 0 &&
            features?.benefits?.map((feature, index) => (
              <EachFeature key={index} feature={feature} />
            ))}
        </Slider>
      </div>
      <Button data={feature_button} />
    </div>
  );
};

Features.propTypes = {
  data: PropTypes.object,
};
export default Features;
